import React from 'react';
import {
  Box,
  Tabs,
  Tab,
} from '@mui/material';

const CampaignTabs = ({
  activeTab,
  onTabChange,
  campaignType,
  isEdit = false,
}) => {
  const getTabs = () => {
    if (campaignType === 'reminder') {
      return isEdit ? [
        'Basic Information',
        'Message Config & Schedule Settings',
        'Test'
      ] : [
        'Basic Information',
        'Message Config & Schedule Settings',
        'Test',
        'Review & Activate'
      ];
    }
    
    return isEdit ? [
      'Basic Information',
      'Message Configuration',
      'Schedule Settings',
      'Test'
    ] : [
      'Basic Information',
      'Message Configuration',
      'Schedule Settings',
      'Test',
      'Review & Activate'
    ];
  };

  const tabs = getTabs();

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs value={activeTab} onChange={onTabChange}>
        {tabs.map((label) => (
          <Tab key={label} label={label} />
        ))}
      </Tabs>
    </Box>
  );
};

export default CampaignTabs; 